const MissingInputCheck = {
	checkMissingInput(el, e) {
		this.missingInput = el.querySelector('.missing-input-check');
		this.applyBtn = document.getElementById('applyBtn');
		this.applyForm = document.getElementById('applyForm');
		if (this.missingInput === undefined) {
			return true;
		}
		this.missingInputHeader = this.missingInput?.dataset?.missingInputHeader;
		this.missingInputBody = this.missingInput?.dataset?.missingInputBody;
		if (this.missingInputHeader === '' || this.missingInputBody === '') {
			return true;
		}
		this.missingInputContainer = el.querySelector('.missing-input__container')
			? el.querySelector('.missing-input__container')
			: el.querySelector('.missing-input-check');
		this.el = el;
		this.isCheckboxes = el?.dataset?.isCheckboxes;
		this.isRadio = el?.dataset?.isRadio;
		if (this.isRadio) {
			this.radioQuestions = Array.from(this.el.querySelectorAll('.radio-question'));
			this.missingInputRadio = false;
			this.radioQuestions.forEach((question) => {
				if (question.querySelectorAll('input[type=radio]:checked').length <= 0) {
					this.missingInputRadio = true;
				}
			});
			this.missingInputFields = el.querySelectorAll('.missing-input-check');
		}
		if (this.isCheckboxes) {
			this.checkboxes = this.missingInput?.querySelectorAll('.form__checkbox-item-container');
		}
		if (
			this.isCheckboxes &&
			this.missingInput?.querySelectorAll('input[type=checkbox]:checked').length <= 0
		) {
			this.addMissingInputBubble(e);
		} else if (this.isRadio && this.missingInputRadio) {
			this.addMissingInputBubble(e);
		} else if (this.missingInput?.value?.trim() === '') {
			this.addMissingInputBubble(e);
		} else {
			if (this.applyForm) {
				this.applyForm.submit();
			}
			this.el.removeAttribute('data-missing-input');
			return true;
		}
		return false;
	},

	addMissingInputBubble(e) {
		e.preventDefault();
		this.missingInputContainer.scrollIntoView({
			behavior: 'smooth',
			block: 'center',
			inline: 'nearest',
		});
		this.missingInputContainer.insertAdjacentHTML(
			'afterend',
			`<div class="tip-container tip-container--missing-input"><p class="missing-input__heading">${this.missingInputHeader}</p><p class="no-margin--bottom">${this.missingInputBody}</p></div>`
		);
		if (this.isRadio) {
			this.missingInputFields.forEach((field) => {
				field.classList.add('textarea--extra-focus');
			});
		} else if (this.isCheckboxes) {
			this.checkboxes.forEach((checkbox) => {
				checkbox.classList.add('textarea--extra-focus');
			});
		} else {
			this.missingInputContainer.classList.add('textarea--extra-focus');
		}
		if (this.applyBtn) {
			this.applyBtn.disabled = false;
		}
		this.el.removeAttribute('data-missing-input');
		return false;
	},
};

export default MissingInputCheck;
